
import { reduce } from 'vessel/utils'

import Suggestions from '@/graphql/queries/product/Suggestions'

const tabs = [
  {
    title: 'newArrivals',
    variables: {
      order: 'createdAt_DESC'
    }
  },
  {
    title: 'onSale',
    variables: {
      where: { onSale: true },
      order: 'score_ASC'
    }
  },
  {
    title: 'featured',
    variables: {
      where: { featured: true },
      order: 'sortOrder_ASC'
    }
  }
]

export default {
  vessel: {
    tab: {
      paddingX: 'md',
      borderBottomWidth: '2',
      fontWeight: 'semibold',
      whiteSpace: 'no-wrap',
      fontSize: 'sm',
      width: 'full',
      cursor: 'pointer',
      paddingY: 'xs',
      xl: {
        fontSize: 'md',
        paddingX: 'lg'
      }
    }
  },
  async fetch() {
    const { fullData } = await this.$graphql.query({
      clientId: 'eshop',
      query: Suggestions
    })

    this.tabs = reduce(tabs, (visible, tab) => {
      const counter = fullData[tab.title]

      if (counter && counter.total > 0) {
        visible.push(tab)
      }
    })
  },
  data() {
    return {
      tabs: [],
      activeIndex: 0
    }
  },
  computed: {
    activeTab() {
      return this.tabs[this.activeIndex]
    }
  },
  methods: {
    isActive(index) {
      return this.activeIndex == index
    },
    onClick(index) {
      this.activeIndex = index || 0
    }
  }
}
